import { liftPlanUEService } from '@/services/lift-plan-ue/lift-plan-ue-service';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';

export const useLiftPlanUEDeleteMutation = (projectId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['liftPlanUEService', 'delete', projectId],
    mutationFn: ({ liftPlanId }: { liftPlanId: string }) =>
      liftPlanUEService.delete(projectId, liftPlanId),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: projectKeys.liftPlanUE({ projectId }) }),
  });
};
